/**
 * @generated SignedSource<<0ac16c6e54cb267c8ea6c5be87f68b78>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type CareType = "CAREER_COACHING" | "COACHING" | "HYBRID_CARE" | "THERAPEUTIC_STRUCTURED" | "THERAPEUTIC_UNSTRUCTURED";
export type ConversationStarterPlatform = "MOBILE" | "OLIATWORK_HOME" | "OLIATWORK_PLAYBOOKS" | "OLIATWORK_SLACK" | "SLACK" | "WEB";
export type PopularTopicsCompanionWidgetQuery$variables = {
  platforms?: ReadonlyArray<ConversationStarterPlatform> | null | undefined;
};
export type PopularTopicsCompanionWidgetQuery$data = {
  readonly conversationStarters: {
    readonly nodes: ReadonlyArray<{
      readonly careType: CareType;
      readonly emoji: string | null | undefined;
      readonly id: string;
      readonly key: string;
      readonly starter: string;
      readonly title: string;
      readonly translations: ReadonlyArray<{
        readonly language: string;
        readonly starter: string;
      }> | null | undefined;
    }>;
  };
};
export type PopularTopicsCompanionWidgetQuery = {
  response: PopularTopicsCompanionWidgetQuery$data;
  variables: PopularTopicsCompanionWidgetQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "platforms"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "starter",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Literal",
        "name": "isActive",
        "value": true
      },
      {
        "kind": "Variable",
        "name": "platforms",
        "variableName": "platforms"
      }
    ],
    "concreteType": "ConversationStarterConnection",
    "kind": "LinkedField",
    "name": "conversationStarters",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ConversationStarter",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "key",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "emoji",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "careType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ConversationStarterTranslation",
            "kind": "LinkedField",
            "name": "translations",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "language",
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "PopularTopicsCompanionWidgetQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "PopularTopicsCompanionWidgetQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "b766d363b4a311b73186ee0d7c7664b8",
    "id": null,
    "metadata": {},
    "name": "PopularTopicsCompanionWidgetQuery",
    "operationKind": "query",
    "text": "query PopularTopicsCompanionWidgetQuery(\n  $platforms: [ConversationStarterPlatform!]\n) {\n  conversationStarters(isActive: true, platforms: $platforms) {\n    nodes {\n      id\n      key\n      title\n      starter\n      emoji\n      careType\n      translations {\n        language\n        starter\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "b9e3fc6e35f38ed8db09a721aa88ae18";

export default node;
